import { ethers as r } from "ethers";
import { OptionFactoryContractAbi as n } from "@deorderbook/contracts/abi";
import { OptionFactoryAddress as c } from "@deorderbook/contracts";
import { signer as e, provider as i } from "./provider.mjs";
const a = () => new r.Contract(
  c,
  n
), y = (o = !1) => {
  const t = a();
  return o ? t.connect(e) : t.connect(i);
};
export {
  a as initOptionFactoryContract,
  y as useOptionFactoryContract
};
//# sourceMappingURL=optionFactoryContract.mjs.map
